export default "__VITE_ASSET__Btl74kiz__"